import { RPDF } from '../common/react-pdf';
import { CalendarType, DayOfWeek } from '@lmt/shared-types';

import { getFormattedLongMonthAndYear } from '@lmt/unicorn-shared/app/components/patients/common';
import React from 'react';

import { ReportInfoTitle } from './ReportInfoTitle';
import {
  getWeekDays,
  getWeeksOfMonth,
} from './calculations/calendar-calculations';

interface Props {
  date: Date;
  calendarType: CalendarType;
  firstDayOfWeekIndex: DayOfWeek;
}

export const ReportMiniCalendar: React.FC<Props> = (props) => {
  const { date, calendarType, firstDayOfWeekIndex } = props;

  function getWeekStyles(index: number, isSelected: boolean) {
    const styles: any[] = [RPDF.calendarStyles.weekContainer];
    if (index === 0) {
      styles.push(RPDF.calendarStyles.firstWeek);
    }
    if (isSelected) {
      styles.push(RPDF.calendarStyles.selectedContainer);
    }
    return styles;
  }

  function getMonthStyles() {
    const styles: any[] = [RPDF.calendarStyles.monthContainer];
    if (calendarType === CalendarType.Month) {
      styles.push(RPDF.calendarStyles.selectedContainer);
    }
    return styles;
  }

  function getDayStyles(day: number) {
    const styles: any[] = [RPDF.calendarStyles.dayContainer];
    if (calendarType === CalendarType.Day && day === date.getDate()) {
      styles.push(RPDF.calendarStyles.selectedContainer);
    }
    return styles;
  }

  return (
    <RPDF.View style={RPDF.calendarStyles.container}>
      <ReportInfoTitle text={getFormattedLongMonthAndYear(date)} />
      <RPDF.View style={RPDF.calendarStyles.calendarContainer}>
        <RPDF.View style={RPDF.calendarStyles.weekContainer}>
          {getWeekDays(firstDayOfWeekIndex).map((title) => (
            <RPDF.View key={title} style={RPDF.calendarStyles.dayContainer}>
              <RPDF.Text style={RPDF.calendarStyles.weekDayTitleText}>
                {title}
              </RPDF.Text>
            </RPDF.View>
          ))}
        </RPDF.View>
        <RPDF.View style={getMonthStyles()}>
          {getWeeksOfMonth(date, calendarType, firstDayOfWeekIndex).map(
            (week, index) => (
              <RPDF.View
                key={`week_${index}`}
                style={getWeekStyles(
                  index,
                  calendarType === CalendarType.Week &&
                    week.includes(date.getDate()),
                )}
              >
                {week.map((day) => (
                  <RPDF.View key={`day_${day}`} style={getDayStyles(day)}>
                    <RPDF.Text>{day}</RPDF.Text>
                  </RPDF.View>
                ))}
              </RPDF.View>
            ),
          )}
        </RPDF.View>
      </RPDF.View>
    </RPDF.View>
  );
};
